module.exports = "https://cdn.realtymogul.com/static/media/icon_tenancy.ad06b0df.svg";